import createReactComponent from '../createReactComponent';
export default createReactComponent('trending-down', 'TrendingDown', [["path",{"d":"m20 17-5.846-5.938c-1.964-1.983-4.106 2.148-6.153.001L4 7m9 10h7v-7","key":"svg-0"}]]);